import { useSyncExternalStore } from 'react';
import { captureStore } from './store';
import { GamepadMessages } from './GamepadMessages';

export const CaptureUi = () => {
  const logs = useSyncExternalStore(captureStore.subscribeLogs, captureStore.getLogs);
  const access = useSyncExternalStore(captureStore.subscribeAccess, captureStore.getAccess);

  const start = () => {
    document.body.requestPointerLock({ unadjustedMovement: true });
    document.body.requestFullscreen();
    navigator.keyboard.lock();
    captureStore.updateAccess({
      mouse: true,
      keyboard: true,
      touch: true,
      gamepad: true,
    });
  };

  return (
    <div className='p-4'>
      <h1>Input Capture Test Page</h1>
      <button onClick={start} className='mt-2 rounded-md bg-yellow-500 px-2 py-1 text-slate-800'>
        Start
      </button>
      <div className='mt-4 flex flex-row gap-16'>
        <div className='flex flex-col'>
          <div data-testid='input-log-entry' className='mb-1 text-xl'>
            Recent Input Events
          </div>
          {logs.map((e, i) => (
            <div key={i}>{e}</div>
          ))}
        </div>
        <div>
          <div className='mb-1 text-xl'>Player Access Rights</div>
          <div>
            <pre>{JSON.stringify(access, null, 4)}</pre>
          </div>
        </div>
        <div>
          <div className='mb-1 text-xl'>Gamepads</div>
          <div>
            <GamepadMessages />
          </div>
        </div>
      </div>
    </div>
  );
};
